module.exports = __webpack_public_path__ + "assets/static/media/hireprivy_splash_screen_3.8f5d93d0.png";